import React, { useEffect, useRef, useState } from "react";
import { EmptyString, InsertDateFormat } from "utils/Constant";
import { money } from "utils/helpers";
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import { FilterCard, MainBodyCard } from "components/Cards";
import { useModal } from "utils/context/ModalContext";
import { DailyTransactionService } from "services/DailyTransactionService/DailyTransactionService";
import DataTable from "components/DataTable";

export default function DailyTransactionReport(){
    const debounceRef = useRef(null)

    const { fetchDailyTransactionList } = DailyTransactionService()

    const { showLoading, hideLoading } = useModal()

    const [dailyTransactionList, setDailyTransactionList] = useState([])

    const [dateFrom, setDateFrom] = useState(new Date())
    const [dateTo, setDateTo] = useState(new Date())
    const [showSalesDetail, setShowSalesDetail] = useState(false)
    const [isToggled, setIsToggled] = useState(false)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center"
        },
        {
            key: "edcName",
            header: "EDC Name",
            render: (row) => row.bankCode + ' - ' + row.edcName,
        },
        {
            key: "salesVolume",
            header: "Sales Volume",
            render: (row) => 'Rp ' + money(String(Math.floor(parseFloat(row.salesVolume))))
        },
    ]
    
    const handleToggle = () => {
        setIsToggled(prev => !prev)
    }
    const dateFromChange = (e) => {
        if (e === null) {
            setDateFrom(new Date())
        }else{
            setDateFrom(e)
        }
    }
    const dateToChange = (e) => {
        if (e === null) {
            setDateTo(new Date())
        }else{
            setDateTo(e)
        }
    }

    const getDailyTransactionList = async () => {
        const res = await fetchDailyTransactionList(
            moment(dateFrom).format(InsertDateFormat),
            moment(dateTo).format(InsertDateFormat), 
            isToggled,
            EmptyString,
            EmptyString
        )
        if (!res) return

        setDailyTransactionList(res)
    }

    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            if (debounceRef.current) {
                clearTimeout(debounceRef.current)
            }
    
            debounceRef.current = setTimeout(async () => {
                showLoading()

                try {
                    await getDailyTransactionList()
                } finally {
                    hideLoading()
                }                
            }, 500)
        }

        onLoad()
    },[isToggled, dateFrom, dateTo])

    return(
        <MainBodyCard>
            <div >
                <span className="font-semibold text-2xl">Daily Transaction Report</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full flex-wrap">
                    <FilterCard title='Date From' width='w-full sm:w-56'>
                        <DatePicker className="w-full" value={dateFrom} onChange={dateFromChange} />
                    </FilterCard>
                    <FilterCard title='Date To' width='w-full sm:w-56'>
                        <DatePicker className="w-full" value={dateTo} onChange={dateToChange} />
                    </FilterCard>
                </div>          
            </div>

            <div className="flex gap-4 items-center justify-end">
                <span>Include Exeption</span>
                <div className="border rounded-md">
                    <button className={`px-4 py-2 bg-black rounded-md ${isToggled ? 'bg-black' : 'bg-white'}`} onClick={handleToggle}>
                        <span className={`${isToggled ? 'text-white' : 'text-black'}`}>ON</span>
                    </button>
                    <button className={`px-4 py-2 bg-black rounded-md ${isToggled ? 'bg-white' : 'bg-black'}`} onClick={handleToggle}>
                        <span className={`${isToggled ? 'text-black' : 'text-white'}`}>OFF</span>
                    </button>
                </div>
            </div>
           
            <div className="hidden xl:block mt-2">
                <DataTable
                    columns={columns}
                    data={dailyTransactionList?.data ?? []}
                />
            </div>

            <div className="block xl:hidden mt-5">
                {dailyTransactionList?.data?.length > 0 ? 
                    <div className="flex flex-col gap-3">
                        {dailyTransactionList?.data?.map((data, i) => {
                            return(
                                <div className="flex flex-col border rounded-md shadow bg-white p-3">
                                    <label className="text-sm">{data.bankCode + " - " + data.edcName}</label>
                                    <label className="text-sm">{data.resellerName === EmptyString ? " - " : data.resellerName}</label>
                                    <label className="text-sm font-semibold">Rp { money(String(Math.floor(parseFloat(data.salesVolume)))) }</label>
                                </div>
                            )
                        })}
                    </div>
                :
                    <div className="text-center">
                        <span>No Transaction Data</span>
                    </div>
                }
            </div>
        </MainBodyCard>
    )
}